import React from "react";
import JsonExporter from "../../Components/JsonExporter/JsonExporter";
import PageTitle from "../../Components/PageTitle/PageTitle";

export default function SellersJsonExporterPage() {
  return (
    <>
      <PageTitle title="Sellers.json Tools" />
      <JsonExporter />
    </>
  );
}
